<script setup lang="ts">

import ApodisPremiumCheckoutButton from "@/subscription-plan/components/apodis-premium/ApodisPremiumCheckoutButton.vue";
import InformationTooltip from "@/core/components/tooltips/InformationTooltip.vue";
import MarkdownView from "@/core/components/markdown/Markdown.vue";

defineProps<{
    features: {
        name: string;
        freemium: string;
        premium: string;
        description?: string;
    }[]
}>();
</script>

<template>
  <div id="feature-grid" class="mx-auto md:max-w-none">
    <div class="grid grid-cols-3">
      <div class="bg-white px-6 pt-10 pb-5 border-b-2 border-slate-200 text-xl font-bold rounded-tl-lg">
        Fonctionnalités
      </div>
      <div class="bg-white px-6 pt-10 pb-5 border-b-2 border-slate-200 text-xl font-bold text-center">
        <p>Freemium</p>
        <p class="text-primary font-medium text-base">
          Notre offre gratuite
        </p>
      </div>
      <div
        class="bg-white px-6 pt-10 pb-5 border-2 border-secondary border-b-slate-200 border-b-2 shadow-[5px_5px_0_0_#65efca] rounded-tr-lg text-xl font-bold text-center"
      >
        <p>Premium</p>
        <p class="text-primary font-medium text-base">
          Pour décoller 🚀
        </p>
      </div>

      <template v-for="(feature) in features" :key="feature.name">
        <div
          class="bg-white px-6 py-2 text-slate-600 border-b-2 flex items-center gap-2"
        >
          <p class="leading-none">
            {{ feature.name }}
          </p>
          <InformationTooltip v-if="feature.description" class="text-primary w-4 h-4">
            <div class="max-w-md">
              <MarkdownView :content="feature.description" inherit-styles class="text-white text-sm" />
            </div>
          </InformationTooltip>
        </div>
        <div
          class="bg-white px-6 py-2 text-slate-600 border-slate-200 text-center border-b-2"
        >
          {{ feature.freemium }}
        </div>
        <div
          class="bg-white px-6 py-2 text-slate-600 text-center border-l-2 border-r-2 border-b-2 border-x-secondary shadow-[5px_5px_0_0_#65efca]"
        >
          {{ feature.premium }}
        </div>
      </template>
      <div class="bg-white rounded-bl-lg" />
      <div class="bg-white" />
      <div
        class="bg-white border-b-2 py-2 border-x-2 border-secondary border-x-secondary rounded-br-lg shadow-[5px_5px_0_0_#65efca] min-h-32 flex items-center justify-center"
      >
        <ApodisPremiumCheckoutButton />
      </div>
    </div>
  </div>
</template>
